// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HeyAI glass design tokens sourced from the HeyAI asset pack CSS. */
:root {
  --heyai-icon-black: #111827;
  --heyai-icon-black-soft: rgba(17, 24, 39, 0.72);
  --heyai-icon-white: rgba(255, 255, 255, 0.92);
  --heyai-accent: #77AFFF;

  --heyai-glass-bg: rgba(255, 255, 255, 0.22);
  --heyai-glass-bg-strong: rgba(255, 255, 255, 0.36);
  --heyai-glass-border: rgba(255, 255, 255, 0.42);

  --heyai-shadow: 0 18px 42px rgba(10, 18, 32, 0.18);
  --heyai-shadow-soft: 0 8px 24px rgba(10, 18, 32, 0.12);

  --heyai-radius-pill: 999px;
  --heyai-radius-card: 24px;
  --heyai-ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --heyai-ease-in: cubic-bezier(0.5, 0, 0.75, 0);

  /* Widget-local gradient var (pack provides single accent, not two-stop gradient) */
  --heyai-launcher-gradient: linear-gradient(145deg, rgba(255,255,255,0.34), rgba(255,255,255,0.12));
}

@keyframes heyaiPulse {
  0%   { transform: scale(0.86); opacity: 0.72; }
  70%  { transform: scale(1.32); opacity: 0.10; }
  100% { transform: scale(1.38); opacity: 0; }
}

/* Second concentric ring offset by half a cycle for layered depth. */
@keyframes heyaiPulse2 {
  0%   { transform: scale(0.92); opacity: 0.48; }
  70%  { transform: scale(1.52); opacity: 0.06; }
  100% { transform: scale(1.58); opacity: 0; }
}

/* Ambient glow halo behind the launcher while voice is active */
@keyframes heyaiGlow {
  0%   { opacity: 0.55; transform: scale(1.00); }
  50%  { opacity: 0.80; transform: scale(1.06); }
  100% { opacity: 0.55; transform: scale(1.00); }
}

@keyframes heyaiPickerIn {
  from {
    opacity: 0;
    transform: translate3d(18px, 0, 0) scale(0.92);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
    filter: blur(0);
  }
}

@keyframes heyaiPanelIn {
  from {
    opacity: 0;
    transform: translate3d(18px, 16px, 0) scale(0.88);
    filter: blur(5px);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
    filter: blur(0);
  }
}

@keyframes heyaiPanelOut {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
    filter: blur(0);
  }
  to {
    opacity: 0;
    transform: translate3d(16px, 14px, 0) scale(0.90);
    filter: blur(4px);
  }
}

@keyframes heyaiSectionIn {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes heyaiMicIn {
  from {
    opacity: 0;
    transform: translate3d(10px, 8px, 0) scale(0.76);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}

/* Widget-local gradient var for voice-active glow: purple to blue. */
:root {
  --heyai-pulse-gradient: linear-gradient(135deg, rgba(139, 92, 246, 0.38), rgba(119, 175, 255, 0.52));
}

.remstal-voice-widget {
  --rv-primary-color: var(--theme-primary, #80b343);
  --rv-secondary-color: var(--theme-secondary, #ffffff);
  --rv-font-family: var(--theme-font, "Arial, sans-serif");
  --rv-font-size: var(
    --theme-font-size,
    16px
  ); /* Increased default for better readability */
  --rv-border-radius: var(--theme-border-radius, 8px);

  position: fixed;
  z-index: 9999;
  font-family: var(--rv-font-family);
  font-size: var(--rv-font-size);
  user-select: none;
  box-sizing: border-box;
  /* Children (pulse rings, booking CTA) may extend past the launcher box. */
  overflow: visible;
}

/* Thinking dots animation */
@keyframes dot-bounce {
  0%, 80%, 100% {
    opacity: 0.2;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

.remstal-voice-widget *,
.remstal-voice-widget *::before,
.remstal-voice-widget *::after {
  box-sizing: inherit;
}

.heyai-launcher-button {
  transform: translate3d(0, 0, 0) scale(1);
  transition:
    transform 160ms var(--heyai-ease-out),
    box-shadow 180ms var(--heyai-ease-out),
    opacity 160ms var(--heyai-ease-out);
  will-change: transform;
}

.heyai-launcher-button:hover:not(:disabled) {
  transform: translate3d(0, -2px, 0) scale(1.015);
}

.heyai-launcher-button:active:not(:disabled) {
  transform: translate3d(0, 0, 0) scale(0.975);
}

.heyai-mode-picker-motion {
  transform-origin: right center;
  animation: heyaiPickerIn 240ms var(--heyai-ease-out) both;
  will-change: transform, opacity;
}

.heyai-mode-picker-control {
  transition:
    background-color 150ms var(--heyai-ease-out),
    transform 150ms var(--heyai-ease-out);
}

.heyai-mode-picker-control:hover:not(:disabled) {
  background: rgba(255,255,255,0.14) !important;
}

.heyai-mode-picker-control:active:not(:disabled) {
  transform: translate3d(0, 0, 0) scale(0.97);
}

.heyai-panel-stage {
  transform-origin: bottom right;
}

.heyai-text-panel-motion {
  transform-origin: bottom right;
  animation: heyaiPanelIn 280ms var(--heyai-ease-out) both;
  will-change: transform, opacity;
}

.heyai-text-panel-motion--closing {
  pointer-events: none;
  animation: heyaiPanelOut 160ms var(--heyai-ease-in) both;
}

.heyai-panel-section {
  animation: heyaiSectionIn 260ms var(--heyai-ease-out) both;
}

.heyai-panel-section--header {
  animation-delay: 50ms;
}

.heyai-panel-section--body {
  animation-delay: 85ms;
}

.heyai-panel-section--input {
  animation-delay: 120ms;
}

.heyai-panel-voice-mic {
  transform-origin: center;
  animation: heyaiMicIn 260ms var(--heyai-ease-out) 135ms both;
  transition:
    transform 150ms var(--heyai-ease-out),
    box-shadow 180ms var(--heyai-ease-out),
    opacity 150ms var(--heyai-ease-out);
  will-change: transform, opacity;
}

.heyai-panel-voice-mic:hover:not(:disabled) {
  transform: translate3d(0, -2px, 0) scale(1.025);
}

.heyai-panel-voice-mic:active:not(:disabled) {
  transform: translate3d(0, 0, 0) scale(0.96);
}

.heyai-panel-voice-mic--closing {
  pointer-events: none;
  animation: heyaiPanelOut 150ms var(--heyai-ease-in) both;
}

@media (prefers-reduced-motion: reduce) {
  .remstal-voice-widget *,
  .remstal-voice-widget *::before,
  .remstal-voice-widget *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }

  .heyai-text-panel-motion,
  .heyai-text-panel-motion--closing,
  .heyai-mode-picker-motion,
  .heyai-panel-section,
  .heyai-panel-voice-mic,
  .heyai-panel-voice-mic--closing {
    transform: none !important;
    filter: none !important;
  }
}

.rv-button {
  background: var(--rv-primary-color);
  color: var(--rv-secondary-color);
  border: none;
  border-radius: var(--rv-border-radius);
  padding: 12px 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  font-family: var(--rv-font-family);
  font-size: var(--rv-font-size);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 60px;
  min-height: 60px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  justify-content: center;
}

.rv-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.rv-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.rv-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.rv-button.recording {
  background: #e74c3c;
  animation: rv-pulse 1s infinite;
}

.rv-button.connecting {
  background: #f39c12;
  animation: rv-spin 1s linear infinite;
}

.rv-button-icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
  pointer-events: none;
}

.rv-status-indicator {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--rv-secondary-color);
  background: #2ecc71;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.rv-status-indicator.connected {
  opacity: 1;
}

.rv-status-indicator.error {
  background: #e74c3c;
  opacity: 1;
}

.rv-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  margin-bottom: 8px;
  pointer-events: none;
}

.rv-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.8);
}

.remstal-voice-widget:hover .rv-tooltip {
  opacity: 1;
  visibility: visible;
}

/* Position classes */
.rv-position-bottom-right {
  bottom: 20px;
  right: 20px;
}

.rv-position-bottom-left {
  bottom: 20px;
  left: 20px;
}

.rv-position-top-right {
  top: 20px;
  right: 20px;
}

.rv-position-top-left {
  top: 20px;
  left: 20px;
}

/* Animations */
@keyframes rv-pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rv-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Accessibility */
.rv-button:focus {
  outline: 2px solid var(--rv-primary-color);
  outline-offset: 2px;
}

.rv-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Media queries for mobile */
@media (max-width: 768px) {
  .rv-button {
    min-width: 56px;
    min-height: 56px;
    padding: 10px 20px;
  }

  .rv-button-icon {
    width: 20px;
    height: 20px;
  }

  .remstal-voice-widget {
    --rv-font-size: 12px;
  }
}

/* Chat window styles */
.remstal-chat-window {
  width: 300px;
  height: 400px;
  border: 1px solid #ccc;
  border-radius: var(--rv-border-radius);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--rv-secondary-color);
}

.remstal-chat-messages {
  flex-grow: 1;
  padding: 10px;
  overflow-y: auto;
}

.remstal-chat-message {
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: var(--rv-border-radius);
  max-width: 80%;
}

.remstal-chat-message-user {
  background-color: var(--rv-primary-color);
  color: var(--rv-secondary-color);
  align-self: flex-end;
  margin-left: auto;
}

.remstal-chat-message-agent {
  background-color: #f1f1f1;
  color: #333;
  align-self: flex-start;
}

.remstal-chat-input-form {
  display: flex;
  padding: 10px;
  border-top: 1px solid #ccc;
}

.remstal-chat-input {
  flex-grow: 1;
  border: 1px solid #ccc;
  border-radius: var(--rv-border-radius);
  padding: 8px;
  font-family: var(--rv-font-family);
  font-size: var(--rv-font-size);
}

.remstal-chat-send-button {
  background-color: var(--rv-primary-color);
  color: var(--rv-secondary-color);
  border: none;
  border-radius: var(--rv-border-radius);
  padding: 8px 12px;
  margin-left: 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6CAA6C;EAC7C,uBAAuB;;EAEvB,2CAA2C;EAC3C,kDAAkD;EAClD,+CAA+C;;EAE/C,kDAAkD;EAClD,sDAAsD;;EAEtD,0BAA0B;EAC1B,yBAAyB;EACzB,gDAAgD;EAChD,8CAA8C;;EAE9C,mFAAmF;EACnF,kGAAkG;AACpG;;AAEA;EACE,OAAO,sBAAsB,EAAE,aAAa,EAAE;EAC9C,OAAO,sBAAsB,EAAE,aAAa,EAAE;EAC9C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;;AAEA,qEAAqE;AACrE;EACE,OAAO,sBAAsB,EAAE,aAAa,EAAE;EAC9C,OAAO,sBAAsB,EAAE,aAAa,EAAE;EAC9C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;;AAEA,gEAAgE;AAChE;EACE,OAAO,aAAa,EAAE,sBAAsB,EAAE;EAC9C,OAAO,aAAa,EAAE,sBAAsB,EAAE;EAC9C,OAAO,aAAa,EAAE,sBAAsB,EAAE;AAChD;;AAEA;EACE;IACE,UAAU;IACV,8CAA8C;IAC9C,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,wCAAwC;IACxC,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iDAAiD;IACjD,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,wCAAwC;IACxC,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;IACxC,eAAe;EACjB;EACA;IACE,UAAU;IACV,iDAAiD;IACjD,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,gDAAgD;EAClD;EACA;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA,qEAAqE;AACrE;EACE,oGAAoG;AACtG;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;EACrD,wDAAwD;EACxD;;;GAGC,EAAE,6CAA6C;EAChD,mDAAmD;;EAEnD,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC;;;uCAGqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE;;yCAEuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,4DAA4D;EAC5D;;;uCAGqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;;;;;;IAME,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/* HeyAI glass design tokens sourced from the HeyAI asset pack CSS. */\n:root {\n  --heyai-icon-black: #111827;\n  --heyai-icon-black-soft: rgba(17, 24, 39, 0.72);\n  --heyai-icon-white: rgba(255, 255, 255, 0.92);\n  --heyai-accent: #77AFFF;\n\n  --heyai-glass-bg: rgba(255, 255, 255, 0.22);\n  --heyai-glass-bg-strong: rgba(255, 255, 255, 0.36);\n  --heyai-glass-border: rgba(255, 255, 255, 0.42);\n\n  --heyai-shadow: 0 18px 42px rgba(10, 18, 32, 0.18);\n  --heyai-shadow-soft: 0 8px 24px rgba(10, 18, 32, 0.12);\n\n  --heyai-radius-pill: 999px;\n  --heyai-radius-card: 24px;\n  --heyai-ease-out: cubic-bezier(0.22, 1, 0.36, 1);\n  --heyai-ease-in: cubic-bezier(0.5, 0, 0.75, 0);\n\n  /* Widget-local gradient var (pack provides single accent, not two-stop gradient) */\n  --heyai-launcher-gradient: linear-gradient(145deg, rgba(255,255,255,0.34), rgba(255,255,255,0.12));\n}\n\n@keyframes heyaiPulse {\n  0%   { transform: scale(0.86); opacity: 0.72; }\n  70%  { transform: scale(1.32); opacity: 0.10; }\n  100% { transform: scale(1.38); opacity: 0; }\n}\n\n/* Second concentric ring offset by half a cycle for layered depth. */\n@keyframes heyaiPulse2 {\n  0%   { transform: scale(0.92); opacity: 0.48; }\n  70%  { transform: scale(1.52); opacity: 0.06; }\n  100% { transform: scale(1.58); opacity: 0; }\n}\n\n/* Ambient glow halo behind the launcher while voice is active */\n@keyframes heyaiGlow {\n  0%   { opacity: 0.55; transform: scale(1.00); }\n  50%  { opacity: 0.80; transform: scale(1.06); }\n  100% { opacity: 0.55; transform: scale(1.00); }\n}\n\n@keyframes heyaiPickerIn {\n  from {\n    opacity: 0;\n    transform: translate3d(18px, 0, 0) scale(0.92);\n    filter: blur(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scale(1);\n    filter: blur(0);\n  }\n}\n\n@keyframes heyaiPanelIn {\n  from {\n    opacity: 0;\n    transform: translate3d(18px, 16px, 0) scale(0.88);\n    filter: blur(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scale(1);\n    filter: blur(0);\n  }\n}\n\n@keyframes heyaiPanelOut {\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scale(1);\n    filter: blur(0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(16px, 14px, 0) scale(0.90);\n    filter: blur(4px);\n  }\n}\n\n@keyframes heyaiSectionIn {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 8px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes heyaiMicIn {\n  from {\n    opacity: 0;\n    transform: translate3d(10px, 8px, 0) scale(0.76);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0) scale(1);\n  }\n}\n\n/* Widget-local gradient var for voice-active glow: purple to blue. */\n:root {\n  --heyai-pulse-gradient: linear-gradient(135deg, rgba(139, 92, 246, 0.38), rgba(119, 175, 255, 0.52));\n}\n\n.remstal-voice-widget {\n  --rv-primary-color: var(--theme-primary, #80b343);\n  --rv-secondary-color: var(--theme-secondary, #ffffff);\n  --rv-font-family: var(--theme-font, \"Arial, sans-serif\");\n  --rv-font-size: var(\n    --theme-font-size,\n    16px\n  ); /* Increased default for better readability */\n  --rv-border-radius: var(--theme-border-radius, 8px);\n\n  position: fixed;\n  z-index: 9999;\n  font-family: var(--rv-font-family);\n  font-size: var(--rv-font-size);\n  user-select: none;\n  box-sizing: border-box;\n  /* Children (pulse rings, booking CTA) may extend past the launcher box. */\n  overflow: visible;\n}\n\n/* Thinking dots animation */\n@keyframes dot-bounce {\n  0%, 80%, 100% {\n    opacity: 0.2;\n    transform: translateY(0);\n  }\n  40% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n}\n\n.remstal-voice-widget *,\n.remstal-voice-widget *::before,\n.remstal-voice-widget *::after {\n  box-sizing: inherit;\n}\n\n.heyai-launcher-button {\n  transform: translate3d(0, 0, 0) scale(1);\n  transition:\n    transform 160ms var(--heyai-ease-out),\n    box-shadow 180ms var(--heyai-ease-out),\n    opacity 160ms var(--heyai-ease-out);\n  will-change: transform;\n}\n\n.heyai-launcher-button:hover:not(:disabled) {\n  transform: translate3d(0, -2px, 0) scale(1.015);\n}\n\n.heyai-launcher-button:active:not(:disabled) {\n  transform: translate3d(0, 0, 0) scale(0.975);\n}\n\n.heyai-mode-picker-motion {\n  transform-origin: right center;\n  animation: heyaiPickerIn 240ms var(--heyai-ease-out) both;\n  will-change: transform, opacity;\n}\n\n.heyai-mode-picker-control {\n  transition:\n    background-color 150ms var(--heyai-ease-out),\n    transform 150ms var(--heyai-ease-out);\n}\n\n.heyai-mode-picker-control:hover:not(:disabled) {\n  background: rgba(255,255,255,0.14) !important;\n}\n\n.heyai-mode-picker-control:active:not(:disabled) {\n  transform: translate3d(0, 0, 0) scale(0.97);\n}\n\n.heyai-panel-stage {\n  transform-origin: bottom right;\n}\n\n.heyai-text-panel-motion {\n  transform-origin: bottom right;\n  animation: heyaiPanelIn 280ms var(--heyai-ease-out) both;\n  will-change: transform, opacity;\n}\n\n.heyai-text-panel-motion--closing {\n  pointer-events: none;\n  animation: heyaiPanelOut 160ms var(--heyai-ease-in) both;\n}\n\n.heyai-panel-section {\n  animation: heyaiSectionIn 260ms var(--heyai-ease-out) both;\n}\n\n.heyai-panel-section--header {\n  animation-delay: 50ms;\n}\n\n.heyai-panel-section--body {\n  animation-delay: 85ms;\n}\n\n.heyai-panel-section--input {\n  animation-delay: 120ms;\n}\n\n.heyai-panel-voice-mic {\n  transform-origin: center;\n  animation: heyaiMicIn 260ms var(--heyai-ease-out) 135ms both;\n  transition:\n    transform 150ms var(--heyai-ease-out),\n    box-shadow 180ms var(--heyai-ease-out),\n    opacity 150ms var(--heyai-ease-out);\n  will-change: transform, opacity;\n}\n\n.heyai-panel-voice-mic:hover:not(:disabled) {\n  transform: translate3d(0, -2px, 0) scale(1.025);\n}\n\n.heyai-panel-voice-mic:active:not(:disabled) {\n  transform: translate3d(0, 0, 0) scale(0.96);\n}\n\n.heyai-panel-voice-mic--closing {\n  pointer-events: none;\n  animation: heyaiPanelOut 150ms var(--heyai-ease-in) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .remstal-voice-widget *,\n  .remstal-voice-widget *::before,\n  .remstal-voice-widget *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n\n  .heyai-text-panel-motion,\n  .heyai-text-panel-motion--closing,\n  .heyai-mode-picker-motion,\n  .heyai-panel-section,\n  .heyai-panel-voice-mic,\n  .heyai-panel-voice-mic--closing {\n    transform: none !important;\n    filter: none !important;\n  }\n}\n\n.rv-button {\n  background: var(--rv-primary-color);\n  color: var(--rv-secondary-color);\n  border: none;\n  border-radius: var(--rv-border-radius);\n  padding: 12px 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  font-family: var(--rv-font-family);\n  font-size: var(--rv-font-size);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 60px;\n  min-height: 60px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  justify-content: center;\n}\n\n.rv-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.rv-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.rv-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.rv-button.recording {\n  background: #e74c3c;\n  animation: rv-pulse 1s infinite;\n}\n\n.rv-button.connecting {\n  background: #f39c12;\n  animation: rv-spin 1s linear infinite;\n}\n\n.rv-button-icon {\n  width: 24px;\n  height: 24px;\n  fill: currentColor;\n  pointer-events: none;\n}\n\n.rv-status-indicator {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--rv-secondary-color);\n  background: #2ecc71;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.rv-status-indicator.connected {\n  opacity: 1;\n}\n\n.rv-status-indicator.error {\n  background: #e74c3c;\n  opacity: 1;\n}\n\n.rv-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  margin-bottom: 8px;\n  pointer-events: none;\n}\n\n.rv-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 4px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.8);\n}\n\n.remstal-voice-widget:hover .rv-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Position classes */\n.rv-position-bottom-right {\n  bottom: 20px;\n  right: 20px;\n}\n\n.rv-position-bottom-left {\n  bottom: 20px;\n  left: 20px;\n}\n\n.rv-position-top-right {\n  top: 20px;\n  right: 20px;\n}\n\n.rv-position-top-left {\n  top: 20px;\n  left: 20px;\n}\n\n/* Animations */\n@keyframes rv-pulse {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.05);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes rv-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Accessibility */\n.rv-button:focus {\n  outline: 2px solid var(--rv-primary-color);\n  outline-offset: 2px;\n}\n\n.rv-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Media queries for mobile */\n@media (max-width: 768px) {\n  .rv-button {\n    min-width: 56px;\n    min-height: 56px;\n    padding: 10px 20px;\n  }\n\n  .rv-button-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .remstal-voice-widget {\n    --rv-font-size: 12px;\n  }\n}\n\n/* Chat window styles */\n.remstal-chat-window {\n  width: 300px;\n  height: 400px;\n  border: 1px solid #ccc;\n  border-radius: var(--rv-border-radius);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: var(--rv-secondary-color);\n}\n\n.remstal-chat-messages {\n  flex-grow: 1;\n  padding: 10px;\n  overflow-y: auto;\n}\n\n.remstal-chat-message {\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  border-radius: var(--rv-border-radius);\n  max-width: 80%;\n}\n\n.remstal-chat-message-user {\n  background-color: var(--rv-primary-color);\n  color: var(--rv-secondary-color);\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.remstal-chat-message-agent {\n  background-color: #f1f1f1;\n  color: #333;\n  align-self: flex-start;\n}\n\n.remstal-chat-input-form {\n  display: flex;\n  padding: 10px;\n  border-top: 1px solid #ccc;\n}\n\n.remstal-chat-input {\n  flex-grow: 1;\n  border: 1px solid #ccc;\n  border-radius: var(--rv-border-radius);\n  padding: 8px;\n  font-family: var(--rv-font-family);\n  font-size: var(--rv-font-size);\n}\n\n.remstal-chat-send-button {\n  background-color: var(--rv-primary-color);\n  color: var(--rv-secondary-color);\n  border: none;\n  border-radius: var(--rv-border-radius);\n  padding: 8px 12px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
